function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import arrowLeft from 'images/arrow-left.svg';
import arrowRight from 'images/arrow-right.svg';
import close from 'images/close-alt.svg';
import leftBanner from 'srcCss/modules/left-banners/left-banners.module.scss';
import { Carousel } from 'react-bootstrap';
import { useNetworkService } from 'hooks/use-network-service';
import { USER_SET_FLAG_URL } from '../../constants';

var LeftBanners = function LeftBanners(_ref) {
  var banners = _ref.banners;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useState3 = useState(banners),
      _useState4 = _slicedToArray(_useState3, 2),
      elements = _useState4[0],
      setElements = _useState4[1];

  var networkService = useNetworkService();

  if (!elements || !elements.length) {
    return null;
  }

  var setUserFlag = function setUserFlag(key) {
    return new Promise(function (resolve) {
      networkService.post(USER_SET_FLAG_URL, {
        key: key
      }).then(function () {
        resolve();
      });
    });
  };

  var handleSelect = function handleSelect(selectedIndex) {
    setIndex(selectedIndex);
  };

  var setPrev = function setPrev() {
    if (index - 1 < 0) {
      setIndex(elements.length - 1);
      return;
    }

    setIndex(index - 1);
  };

  var setNext = function setNext() {
    if (index + 1 >= elements.length) {
      setIndex(0);
      return;
    }

    setIndex(index + 1);
  };

  var removeItem = function removeItem() {
    var filtered = elements.filter(function (el, idx) {
      return idx !== index;
    });
    setUserFlag(elements[index].key);

    if (!filtered[index]) {
      setIndex(index - 1);
    }

    setElements(filtered);
  };

  var renderCaption = function renderCaption() {
    return /*#__PURE__*/React.createElement("div", {
      className: leftBanner.carouselHeader
    }, elements.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: leftBanner.carouselControlPrev,
      onClick: setPrev
    }, /*#__PURE__*/React.createElement("img", {
      src: arrowLeft
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: leftBanner.carouselControlNext,
      onClick: setNext
    }, /*#__PURE__*/React.createElement("img", {
      src: arrowRight
    }))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: leftBanner.carouselControlClose,
      onClick: removeItem
    }, /*#__PURE__*/React.createElement("img", {
      src: close
    })));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: leftBanner.desktopNavListCarousel
  }, renderCaption(), /*#__PURE__*/React.createElement(Carousel, {
    activeIndex: index,
    onSelect: handleSelect,
    controls: false,
    indicators: false,
    interval: null,
    slide: false
  }, elements.map(function (_ref2) {
    var key = _ref2.key,
        link = _ref2.link,
        bannerUrl = _ref2.bannerUrl,
        banner2xUrl = _ref2.banner2xUrl;
    return /*#__PURE__*/React.createElement(Carousel.Item, {
      key: key
    }, /*#__PURE__*/React.createElement("a", {
      href: link,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("img", {
      className: leftBanner.carouselItemImg,
      src: bannerUrl,
      srcSet: banner2xUrl ? "".concat(banner2xUrl, " 2x") : ''
    })));
  })));
};

export { LeftBanners };